import api from '@/lib/api';
import type { AxiosRequestHeaders } from 'axios';
import { User, AuthResponse } from '@/types/auth';
import { StorageService } from './storage.service';

export interface UpdateProfileData {
  name?: string;
  avatar?: File;
  profileCover?: File;
  whatsapp?: string;
  cpf?: string;
  birthDate?: string;
  themePreference?: 'light' | 'dark';
  gender?: 'MALE' | 'FEMALE' | 'OTHER';
}

export class ProfileService {
  async getProfile(): Promise<User> {
    const response = await api.get<User>('/profile', {
      // Falha em /profile (ex: 401) não desloga — evita logout por erro isolado de permissão/rede
      skipAuthRedirect: true,
    });
    return response.data as User;
  }

  async updateProfile(data: UpdateProfileData): Promise<AuthResponse> {
    const formData = new FormData();
    
    if (data.name !== undefined) {
      formData.append('name', data.name);
    }
    
    if (data.avatar) {
      formData.append('avatar', data.avatar);
    }

    if (data.profileCover) {
      formData.append('profileCover', data.profileCover);
    }

    if (data.whatsapp !== undefined) {
      formData.append('whatsapp', data.whatsapp);
    }

    if (data.cpf !== undefined) {
      formData.append('cpf', data.cpf);
    }

    if (data.birthDate !== undefined) {
      formData.append('birthDate', data.birthDate);
    }

    if (data.themePreference !== undefined) {
      formData.append('themePreference', data.themePreference);
    }

    if (data.gender !== undefined) {
      formData.append('gender', data.gender);
    }

    // Não definir Content-Type - o browser define automaticamente com o boundary
    // correto para multipart/form-data. Definir manualmente quebra o parse no servidor.
    const response = await api.put<AuthResponse>('/profile', formData, {
      transformRequest: [
        (data: FormData, headers?: AxiosRequestHeaders) => {
          if (data instanceof FormData) {
            delete headers?.['Content-Type'];
          }
          return data;
        },
      ],
    });
    
    // Atualizar tokens e usuário no storage
    StorageService.setAccessToken(response.data.accessToken);
    StorageService.setRefreshToken(response.data.refreshToken);
    StorageService.setUser(response.data.user);
    return response.data;
  }
}

export const profileService = new ProfileService();
